let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kEBAh")).then(() => parcelRequire('1MVOF'));